import React from "react";
import { useVehicleData } from "../../hooks/useVehicleData";
import Form from "./Form";
import { getDataFresh } from "../../state/selectors";
import { useSelector } from "react-redux";
import { useInspectionTypeData } from "../../hooks/useInspectionTypeData";
import { useDefaultsData } from "../../hooks/useDefaultsData";
import {useKeysData} from "../../hooks/useKeysData";
import {useUtilData} from "../../hooks/useUtilData";
import Nav from "../Nav/Nav";
import {useParams} from "react-router-dom";

function VehicleForm(props) {
  let dataFresh = useSelector(getDataFresh);
  const {vehicle}  = useParams()
  let vehicle_loaded = useVehicleData(vehicle, dataFresh);
  let inspection_types_loaded = useInspectionTypeData({page_size:100});
  let app_defaults_loaded = useDefaultsData({});
  let keys_loaded = useKeysData({});
  const utilsLoaded = useUtilData({service_pack: 1, department: 1, tracking: 1, type: 1, key: 1, make: 1, model: 1});
  return (
      <div>
        <Nav/>
    <Form
      loaded={
        vehicle_loaded &&
        inspection_types_loaded &&
        app_defaults_loaded &&
        utilsLoaded
      }
      endpoint={props.endpoint}
      history={props.history}
    />
      </div>
  );
}

export default VehicleForm;
